export default "__VITE_ASSET__Bj7EI6Gk__"